import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import DatePicker from './date/DatePicker';
import moment from 'moment';

const UsersReportDone = () => {
  const [data1, setData1] = useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(moment().startOf('day').toDate()); 
  const [selectedEndDate, setSelectedEndDate] = useState(moment().endOf('day').toDate()); 
  const [filteredData, setFilteredData] = useState([]);
  const [dateKey, setDateKey] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await fetch('http://supravitest.iotcom.io/TestData');
        const data1 = await response1.json();
        setData1(data1);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Filter data based on the selected date range
    if (selectedStartDate && selectedEndDate) {
      const startDate = moment(selectedStartDate).startOf('day').toISOString();
      const endDate = moment(selectedEndDate).endOf('day').toISOString();
      const filtered = data1.filter((item) => {
        if (item.time) {
          const itemDate = new Date(item.time);
          return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
        }
        return false;
      });
      setFilteredData(filtered);
    } else {
      // If no date range is selected, show reports for today
      const todayReports = data1.filter((item) => {
        if (item.time) {
          const itemDate = new Date(item.time);
          const today = new Date();
          return (
            itemDate >= new Date(today.getFullYear(), today.getMonth(), today.getDate()) &&
            itemDate <= new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
          );
        }
        return false;
      });
      setFilteredData(todayReports);
    }
  }, [selectedStartDate, selectedEndDate, data1, dateKey]);

  const todayReportsForUsername = data1.filter(
    (report) =>
      report.username === 'Volente2' && new Date(report.time).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
  );

  // Function to count the number of reports for each user
  const countReports = () => {
    const reportCount = {};
    filteredData.forEach((item) => {
      const username = item.username;
      if (username) {
        reportCount[username] = reportCount[username] ? reportCount[username] + 1 : 1;
      }
    });
    return reportCount;
  };

  // Calculate the total count
  const totalCount = Object.values(countReports()).reduce((total, count) => total + count, 0);

  return (
    <div style={{ fontFamily: 'YourChosenFont, sans-serif' }}>
      
      <h2 className="mt-4 mx-4 text-3xl font-sans" style={{ color: '#2196f3' }}>
        No of Reports
      </h2>

      {/* Custom DatePicker */}
      <div className="mt-4 mx-4">
        <DatePicker
          key={dateKey} // Use key to force a re-render
          initialStartDate={selectedStartDate}
          initialEndDate={selectedEndDate}
          setStartDate={(date) => {
            setSelectedStartDate(date);
            setDateKey((prevKey) => prevKey + 1); // Update key to trigger re-render
          }}
          setEndDate={(date) => {
            setSelectedEndDate(date);
            setDateKey((prevKey) => prevKey + 1); // Update key to trigger re-render
          }}
          setIsDataFetched={() => {
            // Your logic for data fetching
          }}
        />
      </div>

      {/* Table */}
      <div
        className="mt-2 mx-5 mb-5"
        style={{
          borderRadius: '13px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Table striped bordered hover style={{ margin: '0' }} className="text-center">
          <thead style={{ backgroundColor: '#2196f3', height: '70px', color: 'white', fontSize: '1.5rem' }}>
            <tr>
              <th style={{ verticalAlign: 'middle' }}>Username</th>
              <th style={{ verticalAlign: 'middle' }}>Number of Reports</th>
              {/* Add more columns as needed */}
            </tr>
          </thead>
          <tbody style={{ fontSize: '1.2rem' }}>
            {Object.entries(countReports()).map(([username, count]) => (
              <tr key={username} style={{ height: '50px', backgroundColor: 'white' }}>
                <td style={{ verticalAlign: 'middle' }}>{username}</td>
                <td style={{ verticalAlign: 'middle' }}>{count}</td>
                {/* Add more cells as needed */}
              </tr>
            ))}
            {/* Total row */}
            <tr key="total" style={{ height: '50px', backgroundColor: 'white' }}>
              <td style={{ verticalAlign: 'middle' }}>Total</td>
              <td style={{ verticalAlign: 'middle' }}>{totalCount}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default UsersReportDone;
